import angular from 'angular';
import addNewInsuranceOfferPopupController
    from '../../shared/popup/add-new-insurance-offer-popup/add-new-insurance-offer-popup.controller';
import insuranceOfferEditPopupController
    from '../../shared/popup/edit-insurance-offer-popup/edit-insurance-offer-popup.controller';

export class InsuranceOffersController {
    filterText = '';

    /*@ngInject*/
    constructor($http, $state, insuranceOffer, $mdPanel, $scope, LeftNav, $q, pageSettings) {
        let vm = this;
        vm.cloakView = true;
        vm._mdPanel = $mdPanel;
        this.$http = $http;
        this.insuranceOffer = insuranceOffer;
        this.LeftNav = LeftNav;
        this.pageSettings = pageSettings;
        this.$state = $state;
        this.transformStudentsData = data => {
            let copy = angular.copy(data);
            _.each(copy, function (item) {
                item.fullName = item.firstName + ' ' + item.lastName;
            });

            return copy;
        };
        this.query = {
            'page': 1,
            'limit': 10,
            'query': null,
            'sort': {
                'field': 'id',
                'order': 'desc'
            }
        };

        this.success = insurances => {
            this.insurances = insurances.data;
            this.insurances.data.push({
                id: 1,
                name: "Ubezpieczenie Skarbowców",
                type: 'other'
            });
            this.insurances.data.push({
                id: 2,
                name: "Ubezpieczenie Skarbowców 2019/2020",
                type: 'other'
            });
            this.insurances.data.push({
                id: 1,
                name: "Ubezpieczenie NNW 2018/2019",
                type: 'nnw'
            });
            this.insurances.data.push({
                id: 2,
                name: "Ubezpieczenie NNW 2019/2020",
                type: 'nnw'
            });
            vm.deferred.resolve();
        };

        this.getStudents = function () {
            vm.deferred = $q.defer();
            vm.promise = vm.deferred.promise;
            insuranceOffer.getDataPage(vm.query).then(vm.success);
        };

        // LISTENERS
        const loadingBarDisabler = $scope.$on('cfpLoadingBar:completed', function () {
            vm.cloakView = false;
            loadingBarDisabler();
        });

        $scope.$watch('vm.filterText', function (text, oldText) {
            if (oldText) {
                vm.query.query = text;
                vm.promise = insuranceOffer.getDataPage(vm.query).then(vm.success);
            }
        }, true);


        // ACTIONS
        vm.showDetails = insurance => {
            console.log(insurance);
        };

        vm.showAddInsuranceOfferPopup = () => {
            let position = vm._mdPanel.newPanelPosition();
            let config = {
                attachTo: angular.element(document.body),
                controller: 'addNewInsuranceOfferPopupController',
                controllerAs: 'vm',
                disableParentScroll: this.disableParentScroll,
                template: require('./../../shared/popup/add-new-insurance-offer-popup/add-new-insurance-offer-popup.pug'),
                hasBackdrop: true,
                panelClass: 'add-new-insurance-offer-popup md-whiteframe-6dp',
                position: position,
                trapFocus: true,
                targetEvent: undefined,
                zIndex: 9,
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: true,
                fullscreen: false,
                resolve: {},
                locals: {
                    refresh: () => {
                        vm.getStudents();
                    }
                }
            };

            vm._mdPanel.open(config);
        };

        vm.showInsuranceOfferEditPopup = insuranceData => {
            console.log(insuranceData);
            let position = vm._mdPanel.newPanelPosition();
            let config = {
                attachTo: angular.element(document.body),
                controller: 'insuranceOfferEditPopupController',
                controllerAs: 'vm',
                disableParentScroll: this.disableParentScroll,
                template: require('./../../shared/popup/edit-insurance-offer-popup/edit-insurance-offer-popup.pug'),
                hasBackdrop: true,
                panelClass: 'insurance-offer-edit-popup md-whiteframe-6dp',
                position: position,
                trapFocus: true,
                targetEvent: undefined,
                zIndex: 9,
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: true,
                fullscreen: false,
                resolve: {
                    insuranceData: () => insuranceData
                }
            };

            vm._mdPanel.open(config);
        };
    }

    addStudent() {
        this.$state.go('main.studentAdd');
    }

    $onInit() {
        this.LeftNav.setActive('clients', 'main.students');
        this.pageSettings.setTitle('APPLICATION.TITLE.GENERAL_CONTRACTS');
        this.pageSettings.setTheme('offers');
        this.getStudents();

    }
}

export default angular.module('ngOskCrmApp.main.insuranceOffers', [addNewInsuranceOfferPopupController, insuranceOfferEditPopupController])
    .component('insuranceOffers', {
        template: require('./insuranceOffers.pug'),
        controller: InsuranceOffersController,
        controllerAs: 'vm'
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/main/insuranceOffers/insuranceOffers.component.js